<!-- 
  2022-09-1
  Problemas con la etiqueta y/o lib ejs-combobox  
-->
<template>
  <div>
  <span class="right"> <b>{{ pricelist.length }}</b> articulos encontrados </span>
  <table class="table table-striped ">
    <thead class="thead-dark">
      <tr><th v-for="thead in theader" :key="thead.id">{{thead.text}}</th></tr>               
     </thead>
    <tr v-for="pricelist in pricelist" :key="pricelist.id">
      <!-- </table> -->
      <td>              
       <!-- Botones Acciones -->
       <v-card 
          flat 
          class="py-0"
          max-width="210"
        >
          <v-card-text class="my-0 py-0">
            <v-row class="text-right" justify="center" >        
              <v-btn-toggle
                v-model="toggle_exclusive"
                mandatory
              >          

              <!-- Edit -->         
                      <v-btn  
                        color="deep-purple warning"
                        v-on:click="getDataProduct(pricelist.id)"
                        v-bind="attrs"
                        >                
                        <!-- v-on:click="editRow = pricelist.id"  -->
                        <!-- v-on="on" -->
                         <!-- v-on:click="pricechangeWoo(pricelist.id)"  -->
                        <v-icon>edit</v-icon>
                      </v-btn>
                    
              <!-- FIN Edit -->
                          
              <!-- View -->                       
                <v-btn
                        color="blue"
                        v-on:click="getProduct(pricelist.id)"
                        v-bind="attrs"
                        v-on="on"
                      >                
                         <!-- v-on:click="pricechangeWoo(pricelist.id)"  -->
                         <v-icon>visibility</v-icon>                         
                </v-btn>                              
              <!-- FIN View -->

              <!-- Copy -->                   
              <!-- v-bind:href="url(pricelist.id)"    -->
                <v-btn
                      color="green darken-1"                
                      v-bind="attrs"
                      v-on="on"
                      @click="copyPricelist(pricelist.id)"
                >                
                         <!-- v-on:click="pricechangeWoo(pricelist.id)"  -->
                         <v-icon>content_copy</v-icon>                         
                </v-btn>                      
              <!-- Copy -->
                  

              </v-btn-toggle>
            </v-row>
          </v-card-text>
      </v-card>  
      <!-- FIN Botones Acciones -->

      
      </td>  
      <td>
        {{pricelist.title}} <br>
        <b>Marca: </b>{{pricelist.brandname}} | <b>Modelo: </b>{{pricelist.modelo}} <br>
      </td>
      <td>
        <center>
          <BarcodeGenerator
          :value="pricelist.id"
          :format="'CODE39'"
          :lineColor="'#000'"
          :width="1"
          :height="20"
          :elementTag="'img'"
          :displayValue=false
          /> <br>
          <small>            
            {{pricelist.sku}} <br>
            <!-- <b>SKU FAB: </b>{{pricelist.modelo}} <br> -->
          </small>
        </center>
      </td>
      <td>{{pricelist.clave_sat}}</td>      
      <td>{{pricelist.type_article}}</td>      
      <td>{{pricelist.linename}}</td>      
      
     
     
    </tr>
  </table>

      <!-- VISTA PRODUCTO DIALOG-->
      <template>                 
                      <v-dialog
                        v-model="dialogViewProduct"
                        persistent
                        max-width="800px"                 
                      >
                          <v-card>
                            <v-card-title>
                              <span class="headline">Detalle Artículo</span>
                              <v-btn
                                class="headline"
                                color="blue darken-1"
                                text
                                @click="dialogViewProduct = false"
                              >
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-card-title>
                            <v-container v-if='this.dialogViewProduct==true'>
                                <ArticleView :productid="productid"  />
                            </v-container>
                            <!-- :pricelist="priceslist -->
                            <!-- buttonText="Guardar"   -->
                          <v-card-actions>
                              <v-btn 
                              
                              color="red" 
                              @click="dialogViewProduct = false"
                              >
                              cerrar
                            </v-btn>
                              <v-spacer></v-spacer>              
                            </v-card-actions>
                          </v-card>                    
                      </v-dialog>
      </template>                 
      <!-- FIN VISTA PRODUCTO  DIALOG-->

      <!-- EDITAR ARTICULO -->
      <template>                 
                          <v-dialog
                            v-model="dialog10"
                            persistent
                            max-width="800px"                 
                          >
                        
                              <v-card>
                                <v-card-title>
                                  <span class="headline">Editar Articulo </span>
                                  <v-btn
                                    class="headline"
                                    color="blue darken-1"
                                    text
                                    @click="dialog10 = false"
                                  >
                                    <v-icon>close</v-icon>
                                  </v-btn>
                                </v-card-title>
                                <v-card-text>
                                  <v-container v-if='this.dialog10==true'>
                                    <ProductEdit :product="product" />                                
                                  </v-container>
                              </v-card-text>
                              <v-card-actions>
                                  <v-btn 
                                    color="red" 
                                    @click="dialog10 = false"
                                  >
                                    cerrar
                                  </v-btn>
                                  <v-spacer></v-spacer>   
                                  <small style="color:red;">*Campos Obligatorios</small>
                                </v-card-actions>
                              </v-card>                    
                          </v-dialog>
      </template>    
      <!-- FIN EDITAR ARTICULO -->

      <!-- EDITAR PRODUCTO MELI -->
      <template>                 
                          <v-dialog
                            v-model="dialogMeli"
                            persistent
                            max-width="800px"                 
                          >
                        
                              <v-card>
                                <v-card-title>
                                  <span class="headline">Editar Articulo Meli</span>
                                  <v-btn
                                    class="headline"
                                    color="blue darken-1"
                                    text
                                    @click="dialogMeli = false"
                                  >
                                    <v-icon>close</v-icon>
                                  </v-btn>
                                </v-card-title>
                                <v-card-text>
                                  <v-container v-if='this.dialogMeli==true'>
                                    <ProductEditMeli :product="product" />
                                  </v-container>
                              </v-card-text>
                              <v-card-actions>
                                  <v-btn 
                                    color="red" 
                                    @click="dialogMeli = false"
                                  >
                                    cerrar
                                  </v-btn>
                                  <v-spacer></v-spacer>   
                                  <small style="color:red;">*Campos Obligatorios</small>
                                </v-card-actions>
                              </v-card>                    
                          </v-dialog>
      </template>    
      <!-- FIN EDITAR PRODUCTO MELI -->
      
      <!-- EDITAR PRODUCTO WOO -->
      <template>                 
                          <v-dialog
                            v-model="dialogWoo"
                            persistent
                            max-width="800px"                 
                          >
                        
                              <v-card>
                                <v-card-title>
                                  <span class="headline">Editar Articulo Woo</span>
                                  <v-btn
                                    class="headline"
                                    color="blue darken-1"
                                    text
                                    @click="dialogWoo = false"
                                  >
                                    <v-icon>close</v-icon>
                                  </v-btn>
                                </v-card-title>
                                <v-card-text>
                                  <v-container v-if='this.dialogWoo==true'>
                                    <ProductEditWoo :product="product" />
                                  </v-container>
                              </v-card-text>
                              <v-card-actions>
                                  <v-btn 
                                    color="red" 
                                    @click="dialogWoo = false"
                                  >
                                    cerrar
                                  </v-btn>
                                  <v-spacer></v-spacer>   
                                  <small style="color:red;">*Campos Obligatorios</small>
                                </v-card-actions>
                              </v-card>                    
                          </v-dialog>
      </template>    
      <!-- FIN EDITAR PRODUCTO WOO -->

</div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
// import{ mapMutations,mapState,mapGetters } from "vuex";
import baseApi from '@/services/baseApi';
// import router from '@/router';
import BarcodeGenerator from "@/components/BarcodeGenerator";
import ProductEdit from "@/components/ArticleEdit";
import ProductEditMeli from "@/components/ProductEditMeli";
import ProductEditWoo from "@/components/ProductEditWoo";
import ArticleView from "@/components/ArticleView";




export default {
  props:{
    pricelist:{
      type:Object,
      required:true
    }
  },
  computed:{
    //'products'
      // ...mapState(['brands','measurements','familycategories','suppliers','currentUser'])
      ...mapState(['currentUser'])
  },
  components: {    
    BarcodeGenerator,
    ArticleView,
    ProductEdit,
    ProductEditWoo,
    ProductEditMeli
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]), 
    url: function (href){
        return 'detalleventasproducto?pricelistid='+ href
    },    
    aumentar(row){ 
      // this.pricelist.qty=0;
      // if(row.qty==null) row.qty=0
      row.qty ++
    },
    disminuir(row){      
      row.qty --
    },
    copyPricelist(id) {
      if(confirm("Desea agregar el articulo "+id+" a la lista de precios?")){
        try{        
          this.showLoading({titulo:"Accediendo información",color:"warning"})                  
          baseApi().get(`/articulos/copyPricelist/${id}`).then((response)=>{
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
            }else{
                this.$swal("Error!",response.data.message+': <br/>'+JSON.stringify(response.data.validate), "error");                
            }                                    
            console.log("Copiar COTIZACION: "+response.data.message);
          });
        }catch(error){
          console.log(error);     
        }  finally{
          this.hiddenLoading()          
          //this.$swal("Genial!", "Se copió la información como ventas", "success");            
        } 
      }else{
        console.log('User'+this.user.name);
        // console.log('CurrentUser: '+this.currentUser.branch_id);
      }
    },
    updateRow(row) {      
      try{                
        this.showLoading({titulo:"Actualizando información",color:"primary"})  
        // alert(row.id)
        baseApi().post(`/precios/update/${row.id}`,JSON.stringify(row)).then((response)=>{        
            if(!response.data.error){                            
              this.$swal("Genial!",response.data.message, "success");
            }else{
              this.$swal("Error!",response.data.message, "error");
            }                                    
            // console.log("VENTA: "+response.data.message);
        });              
      }catch(error){
        console.log('Update Pricelist '+error);
        // if (error.message=='Request failed with status code 500') {
        //   this.$swal("Error!",error.message+"<br/> Intente Nuevamente o verifique todos los campos", "error");
        // }else if(error.message=='Request failed with status code 401'){
        //   this.$swal("Error!", "Ha terminado la sesion <br/>Por seguridad ingrese de nuevo sus credenciales", "error");
        //   router.push('/login');
        // }else{
        //   this.$swal("Error!", "Algo salio mal, Intente nuevamente <br/>"+error, "error");
        // } 
      }  finally{
        this.hiddenLoading()
        // this.$swal("Genial!", "Se actualizó la información", "success");
      } 
    },      
    async addCar(row){
        try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Agregando al Carrito",color:"default"})      
          //let branch_id=this.currentUser.branch_id;          
          let pricelist_id=row.id;
          let price=row.price_publico/1.16; //Se divide 1.16 para que sea el precio sin iva
          let cantidad=row.qty;
          //let cantidad=1;
          //alert("ID:"+price)
          //const { pricelist_id,price, cantidad } = this;        
          await baseApi().post(`/carrito`,JSON.stringify({ pricelist_id,price,cantidad })).then((response)=>{
                if(!response.data.error){        
                  this.$swal("Genial!",response.data.message, "success");
                }else{
                  this.$swal("Error!",response.data.message, "error");
                }                                    
                // console.log("VENTA: "+response.data.message);
          });                      
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
        } 
    },
    async getProduct(ProductID){
      console.log('Producto ID:'+ProductID);
      this.productid=ProductID;
      // alert(this.productid);
      this.dialogViewProduct=true;      
    }, 
    async getProduct2(ProductID){
      this.dialogViewProduct=true;
      console.log('Producto ID:'+ProductID);
      baseApi().get(`/precios/${ProductID}`).then((response)=>{
              if(!response.data.error){                            
                // this.$swal("Genial!",response.data.message, "success");
                this.productrow=response.data
                // this.rows.productfilename=response.data.filename
                //alert(this.rows.productfilename)

              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                    
      });
    }, 
    getDataProduct(priceid) {      
          let id={pricelist_id: priceid}; //no se para que
          // alert(id.pricelist_id);
          // this.product=row
          this.product=id
          this.dialog10=true
    }, 
    getDataProductMeli(priceid) {      
          let id={pricelist_id: priceid}; //no se para que
          this.product=id
          this.dialogMeli=true
    },  
    getDataProductWoo(priceid) {      
          let id={pricelist_id: priceid}; //no se para que
          this.product=id
          this.dialogWoo=true
    },  
    async setDataProductWoo(priceid) {               
          try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Crear registro de Woo",color:"blue"})
          
          await baseApi().get('/precios/wooaddone/'+priceid).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 

    },
    async setDataProductMeli(priceid) {               
          try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Crear registro de Mercado Libre",color:"blue"})
          
          await baseApi().get('/precios/meliaddone/'+priceid).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 

    }, 
    async addDataProductMeli(priceid) {               
          try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Subir informacion a Mercado Libre",color:"blue"})
          await baseApi().get('/mlibre/add/article/'+priceid).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 

    }, 
    async upProductMeli(id){
        try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Subir informacion a Mercado Libre",color:"blue"})
          
          await baseApi().get('/mlibre/updatepriceone/'+id).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 
    },
    async syncDataProductMeli(id){
        try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Subir informacion a Mercado Libre",color:"blue"})
          
          await baseApi().get('/mlibre/syncpriceone/'+id).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 
    },
    async upProductSyscom(id){
        try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Obtener informacion de Syscom",color:"blue"})
          
          await baseApi().get('/syscom/updatepriceone/'+id).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 
    },
    async upProductCTOnline(id){
        try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Obtener informacion de CTOnline",color:"red"})
          
          await baseApi().get('/ctconnect/updatepriceone/'+id).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 
    },
    async upProductCVA(id){
        try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Obtener informacion de CVA",color:"green"})
          
          await baseApi().get('/cva/updatepriceone/'+id).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 
    },
    async upProductWoo(id){
        try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Creado el producto en Woocommerce",color:"default"})
          
          await baseApi().get('/woo/products/create/'+id).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 
    },
    async pricechangeWoo(id){
        try{        
          //console.log(this.sword2);       
          this.showLoading({titulo:"Actualizando el precio en Woocommerce",color:"default"})
          // let branchID=this.currentUser.branch_id;          
          // await baseApi().get('/woo/products/updatepriceone/'+id+'?branch_id='+branchID).then((response)=>{  
          await baseApi().get('/woo/products/updatepriceone/'+id).then((response)=>{  
            if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message+"2", "error");
              }                                          
          });          
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", this.rdesc, this.rtitle);
        } 
    },
  },
  data(){
    return{
      // attribute: {sword: 'All',limit: 500},
      editRow: null,
      dialog10:false,
      dialogMeli:false,
      dialogWoo:false,
      dialogViewProduct:false,
      alertCar:false,
      toggle_exclusive:false,
      productrow:{},
      product:{},
      theader: [
          { text: '', value: 'name' },
          { text: 'Descripcion', value: 'name' },
          { text: 'sku', value: 'constructionDate' },
          { text: 'clave sat', value: 'constructionDate' },
          { text: 'tipo', value: 'location' },
          { text: 'linea/giro', value: 'location' }          
      ],
      itemsStatus:[        
          'Público',
          'Privado',
          'Descontinuado',
      ],
      dataFields:{value:'id',text:'game'},
      itemsTypeArticle:[
         //'KIT',
         'Productos',
         'Servicios',
      ],
      dataIArticle:[
         {id: 'KIT', game: 'KIT'},
         {id: 'Productos', game: 'Productos'},
         {id: 'Servicios', game: 'Servicios'}         
        ],
      dataFArticle:{value:'id',text:'game'}
    }
  }
}
</script>

<style>
  .v-card__title{
    height: 155px;
    align-content: baseline;
    font-size:1rem;
    line-height:1.5rem;
    padding-top: 1rem;
    padding-bottom: 2rem;
  }  
</style>